import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "title"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CropperModal = _resolveComponent("CropperModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePrimaryAction && _ctx.handlePrimaryAction(...args))),
          src: _ctx.thumbnailSrc,
          title: _ctx.result.title,
          class: "image-result h-36 w-36 min-w-36 cursor-pointer rounded-2xl object-cover shadow-sm ring-1 ring-slate-200 transition duration-200 hover:-translate-y-1 hover:shadow-lg hover:ring-blue-300 sm:h-40 sm:w-40 sm:min-w-40"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      src: _ctx.thumbnailSrc,
      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageLoaded && _ctx.onImageLoaded(...args))),
      style: {"display":"none"}
    }, null, 40, _hoisted_2),
    _createVNode(_component_CropperModal, {
      open: _ctx.isOpen,
      result: _ctx.result,
      onApplied: _ctx.applyUpdate,
      onClosed: _ctx.closeCropper
    }, null, 8, ["open", "result", "onApplied", "onClosed"])
  ], 64))
}